

class Room {

    private static instance: Room;

    public static getInstance(): Room {
        if (!Room.instance) {
            Room.instance = new Room();
        }
        return Room.instance;
    }

    _room: any ;
    _roomInstance: any;

    public updateRoom(newRoom: any) {
        this._room = newRoom;
    }

    public updateRoomInstance(newRoomInstance: any) {
        this._roomInstance = newRoomInstance;
    }

    public getRoomInstance() {
        return this._roomInstance;
    }

    public getRoom() {
        return Room.getInstance()._room;
    }

}

export {
    Room
}